{{ value | numberRenderer }}
